export default "__VITE_ASSET__4bjD$OTA__"